import { createContext } from "react";
export const TransferClientContext = createContext();
